/* eslint-disable react/button-has-type */
import { useState } from 'react';
import { PMI_WELCOME_VIDEO_URL } from '../../constants';
import getEmbedVideoLink from './getEmbedVideoLink';
import styles from './videoEmbed.module.scss';

export default function EmbedVideo({
  url,
  transcript,
  onModal = false,
}: {
  url: string;
  transcript: string;
  onModal?: boolean;
}) {
  let embedLink = null;
  const [open, setOpen] = useState<boolean>(false);

  if (url) {
    embedLink = getEmbedVideoLink(url);
  } else {
    embedLink = getEmbedVideoLink(PMI_WELCOME_VIDEO_URL);
  }
  return (
    <div className="d-flex flex-column w-100 h-100">
      <div
        className={`position-relative overflow-hidden ${styles.embedContainer}`}
      >
        <iframe
          src={`${embedLink}${onModal ? '?autoplay=1' : ''}`}
          title="video-palyer"
          className="position-absolute w-100 h-100"
          allow="autoplay"
          allowFullScreen
        />
      </div>
      <div className="pt-2">
        {transcript ? (
          <button
            onClick={() => setOpen(!open)}
            className={`mt-2 mb-3 d-block ${styles.toggler}`}
          >
            {open ? '- Hide Video Transcript' : '+ Show Video Transcript'}
          </button>
        ) : null}
        {open && <div className={styles.transcript}>{transcript}</div>}
      </div>
    </div>
  );
}
